export enum ChainingCatalogContextEnum {
    CONTEXT_DRUG = "drug",
    CONTEXT_WMA = "wma",
    CONTEXT_CARE = "care",
    CONTEXT_OPERATION = "intervention",
    CONTEXT_MIX = "mix",
    CONTEXT_BASE = "base"
}
